import {
  TZyomuinAlcoholHannoListItem,
  TZyomuinClaimListItem,
  TZyomuinHyosyorekiListItem,
  TZyomuinJikorekiListItem,
  TZyomuinKeirekiListItem,
  TZyomuinMenkyoFileListItem,
  TZyomuinMenkyoKosinListItem,
  TZyomuinSidorekiListItem,
  TZyomuinSikakuListItem,
  TZyomuinSyozokuBusyoIdoHstListItem,
  TZyomuinUntenKirokuListItem,
  TZyomuinZenrekiListItem,
} from "../../../service/driver/TZyomuin"

/**
 * 前歴
 */
export type TZenrekiDataTable = {
  前歴データリスト: TZenrekiData[]
}

export type TZenrekiData = Partial<TZyomuinZenrekiListItem> & {
  input入学入社日?: string
  input卒業退社日?: string
  row_id?: string
}

/**
 * 経歴
 */
export type TKeirekiDataTable = {
  経歴データリスト: TKeirekiData[]
}

export type TKeirekiData = Partial<TZyomuinKeirekiListItem> & {
  row_id?: string
}

/**
 * 資格
 */
export type TSikakuDataTable = {
  資格データリスト: TSikakuData[]
}

export type TSikakuData = Partial<TZyomuinSikakuListItem> & {
  input資格取得日?: string
  row_id?: string
}

/**
 * 表彰歴
 */
export type THyosyorekiDataTable = {
  表彰歴データリスト: THyosyorekiData[]
}

export type THyosyorekiData = Partial<TZyomuinHyosyorekiListItem> & {
  input表彰日?: string
  row_id?: string
}

/**
 * 指導懲戒歴
 */
export type TSidoTyokairekiDataTable = {
  指導懲戒歴データリスト: TSidoTyokairekiData[]
}

export type TSidoTyokairekiData = Partial<TZyomuinSidorekiListItem> & {
  input指導懲戒日?: string
  row_id?: string
}

/**
 * 免許更新履歴
 */
export type TMenkyoKosinRirekiDataTable = {
  免許更新履歴データリスト: TMenkyoKosinRirekiData[]
}

export type TMenkyoKosinRirekiData = Partial<TZyomuinMenkyoKosinListItem> & {
  input免許更新日?: string
  input有効期限?: string
  input面談日?: string
  row_id?: string
}

/**
 * 免許ファイル一覧
 */
export type TMenkyoFileDataTable = {
  免許ファイルリスト: TMenkyoFileData[]
}

export type TMenkyoFileData = Partial<TZyomuinMenkyoFileListItem> & {
  row_id?: string
  HasファイルAtStart: boolean
  ファイル?: TMenkyoFile
}

export type TMenkyoFile = {
  isNewFile: boolean
  ファイルURL: string
  ファイル名: string
}

/**
 * 事故歴
 */
export type TZikorekiDataTable = {
  事故歴データリスト: TZikorekiData[]
}

export type TZikorekiData = Partial<TZyomuinJikorekiListItem> & {
  row_id: string
  input発生日?: string
  Has添付ファイルAtStart: boolean
  添付ファイル?: TZikorekiFile
}

export type TZikorekiFile = {
  isNewFile: boolean
  ファイルURL: string
  ファイル名: string
}

/**
 * 運転記録証明
 */
export type TUntenKirokuSyomeiDataTable = {
  運転記録証明データリスト: TUntenKirokuSyomeiData[]
}

export type TUntenKirokuSyomeiData = Partial<TZyomuinUntenKirokuListItem> & {
  input違反日?: string
  row_id?: string
}

/**
 * クレーム歴
 */
export type TClaimrekiDataTable = {
  クレーム歴データリスト: TClaimrekiData[]
}

export type TClaimrekiData = Partial<TZyomuinClaimListItem> & {
  row_id: string
  Has添付ファイルAtStart: boolean
  添付ファイル?: TClaimrekiFile
}

export type TClaimrekiFile = {
  isNewFile: boolean
  ファイルURL: string
  ファイル名: string
}

/**
 * アルコール反応
 */
export type TAlcoholDataTable = {
  アルコール反応データリスト: TAlcoholData[]
}

export type TAlcoholData = Partial<TZyomuinAlcoholHannoListItem> & {
  row_id?: string
  // 入力用
  測定日時_入力用?: Date
}

/**
 * 部所異動履歴
 */
export type TZyomuinSyozokuBusyoIdoDataTable = {
  部所異動履歴データリスト: TZyomuinSyozokuBusyoIdoData[]
}

export type TZyomuinSyozokuBusyoIdoData =
  Partial<TZyomuinSyozokuBusyoIdoHstListItem> & {
    row_id?: string
  }

//#region 初期値

export const initialZenrekiDataTable: TZenrekiDataTable = {
  前歴データリスト: [],
}

export const initialKeirekiDataTable: TKeirekiDataTable = {
  経歴データリスト: [],
}

export const initialSikakuDataTable: TSikakuDataTable = {
  資格データリスト: [],
}

export const initialHyosyorekiDataTable: THyosyorekiDataTable = {
  表彰歴データリスト: [],
}

export const initialSidoTyokairekiDataTable: TSidoTyokairekiDataTable = {
  指導懲戒歴データリスト: [],
}

export const initialMenkyoKosinRirekiDataTable: TMenkyoKosinRirekiDataTable = {
  免許更新履歴データリスト: [],
}

export const initialMenkyoFileDataTable: TMenkyoFileDataTable = {
  免許ファイルリスト: [],
}

export const initialZikorekiDataTable: TZikorekiDataTable = {
  事故歴データリスト: [],
}

export const initialUntenKirokuSyomeiDataTable: TUntenKirokuSyomeiDataTable = {
  運転記録証明データリスト: [],
}

export const initialClaimrekiDataTable: TClaimrekiDataTable = {
  クレーム歴データリスト: [],
}

export const initialAlcoholDataTable: TAlcoholDataTable = {
  アルコール反応データリスト: [],
}

//#endregion
